const SEPARADOR = ' | '
// Milhar pt-BR ("1.000", "1.000,5"): ponto só agrupa de 3 em 3 dígitos e o primeiro
// grupo não começa em 0 ("0.500" é meio, não 500).
const MILHAR_PTBR = /^[1-9]\d{0,2}(\.\d{3})+(,\d+)?$/
// Decimal simples, com vírgula ou ponto, parte inteira opcional ("2,5", "2.5", ",5").
const DECIMAL = /^(\d+|\d*[.,]\d+)$/

// Regra: ponto seguido de exatamente 3 dígitos é milhar ("2.500" = 2500);
// qualquer outro ponto é decimal ("2.5" = 2,5). Inválido devolve NaN.
export function parseQuantidade(bruto: string): number {
    const s = bruto.trim()
    if (MILHAR_PTBR.test(s)) return Number(s.replace(/\./g, '').replace(',', '.'))
    if (DECIMAL.test(s)) return Number(s.replace(',', '.'))
    return NaN
}

// Quantidade e unidade POR LINHA no modo de múltiplos itens: "descrição | qtd | unidade".
// O separador tem espaços para não partir descrição com barra vertical colada;
// qtd inválida ou <= 0 vira 1 (nunca zera o total).
export function parseLinhaItem(linha: string): {
    descricao: string
    quantidade: number
    unidade: string
} {
    const partes = linha.split(SEPARADOR).map((p) => p.trim())
    const qtd = parseQuantidade(partes[1] || '')
    return {
        descricao: partes[0] || linha.trim(),
        quantidade: Number.isFinite(qtd) && qtd > 0 ? qtd : 1,
        unidade: partes[2] || 'Unidade',
    }
}

// Troca só a descrição da linha, preservando o sufixo " | qtd | unidade" digitado.
export function trocarDescricao(linha: string, descricao: string): string {
    const partes = linha.split(SEPARADOR)
    partes[0] = descricao
    return partes.join(SEPARADOR)
}
